import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";
import { items } from "./items";
import { accounts } from "./accounts";
import { taxTemplates } from "./tax-templates";

// ============================================================================
// invoice_items — รายการในใบแจ้งหนี้
// ============================================================================
export const invoiceItems = sqliteTable("accounting_invoice_items", {
  id: text("id").primaryKey(), // ULID
  // Polymorphic FK to one of the accounting-owned invoice/note tables:
  // accounting_sales_invoices, accounting_purchase_invoices,
  // accounting_sales_credit_notes, accounting_sales_debit_notes,
  // accounting_purchase_debit_notes.
  invoiceId: text("invoice_id").notNull(),
  itemId: text("item_id").references(() => items.id), // FK → items (nullable for manual entry)
  description: text("description"),
  qty: real("qty").notNull().default(1),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  accountId: text("account_id").references(() => accounts.id), // FK → accounts (override item default)
  taxTemplateId: text("tax_template_id").references(() => taxTemplates.id), // FK → tax_templates
  taxAmount: real("tax_amount").notNull().default(0),
  unitOfMeasure: text("unit_of_measure"),  // หน่วยนับ (ชิ้น, กล่อง, คัน)
  discountRate: real("discount_rate").default(0),  // ส่วนลด %
  discountAmount: real("discount_amount").default(0),  // ส่วนลดเป็นเงิน (calculated: amount * discountRate / 100, or manual)
  whtRate: real("wht_rate").default(0),  // อัตรา WHT %
  whtAmount: real("wht_amount").default(0),  // จำนวน WHT
  netAmount: real("net_amount").default(0),  // amount - discountAmount (before tax)
  lineType: text("line_type"), // Extensible: goods, service, rental, deposit_refundable, deposit_applied, etc.
  lineTaxPointDate: text("line_tax_point_date"),
  lineVatStatus: text("line_vat_status", { enum: ["undue", "due"] }),
  costCenterId: text("cost_center_id"), // FK → cost_centers (nullable)
  // Polymorphic line-level reference (EPIC #412 Phase 1) — links the invoice
  // line back to its source entity (vehicle/asset/rental/etc.) so analytic
  // reports can group revenue or COGS per dimension. Posting service copies
  // this onto the resulting gl_entries row.
  lineReferenceModule: text("line_reference_module"),
  lineReferenceDoctype: text("line_reference_doctype"),
  lineReferenceId: text("line_reference_id"),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  invItemLineRefIdx: index("inv_item_line_ref_idx").on(table.lineReferenceModule, table.lineReferenceId),
}));

// Type exports
export type InvoiceItem = typeof invoiceItems.$inferSelect;
export type NewInvoiceItem = typeof invoiceItems.$inferInsert;
